import {
  CREATE_ADMIN_AIRTICKET_FAIL,
  CREATE_ADMIN_AIRTICKET_REQUEST,
  CREATE_ADMIN_AIRTICKET_SUCCESS,
  DELETE_ADMIN_AIRTICKET_FAIL,
  DELETE_ADMIN_AIRTICKET_REQUEST,
  DELETE_ADMIN_AIRTICKET_SUCCESS,
  GET_ADMIN_AIRTICKET_LIST_FAIL,
  GET_ADMIN_AIRTICKET_LIST_REQUEST,
  GET_ADMIN_AIRTICKET_LIST_SUCCESS,
  UPDATE_ADMIN_AIRTICKET_FAIL,
  UPDATE_ADMIN_AIRTICKET_REQUEST,
  UPDATE_ADMIN_AIRTICKET_SUCCESS,
} from "../../types/admin/airTicketTypes";

export const createAdminAirTicketReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case CREATE_ADMIN_AIRTICKET_REQUEST:
      return {
        ...state,
        createAdminAirTicketLoading: true,
      };
    case CREATE_ADMIN_AIRTICKET_SUCCESS:
      return {
        ...state,
        createAdminAirTicketLoading: false,
        createAdminAirTicketInfo: payload,
        createAdminAirTicketError: "",
      };
    case CREATE_ADMIN_AIRTICKET_FAIL:
      return {
        ...state,
        createAdminAirTicketLoading: false,
        createAdminAirTicketInfo: [],
        createAdminAirTicketError: payload,
      };
    default:
      return state;
  }
};

export const updateAdminAirTicketReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case UPDATE_ADMIN_AIRTICKET_REQUEST:
      return {
        ...state,
        updateAdminAirTicketLoading: true,
      };
    case UPDATE_ADMIN_AIRTICKET_SUCCESS:
      return {
        ...state,
        updateAdminAirTicketLoading: false,
        updateAdminAirTicketInfo: payload,
        updateAdminAirTicketError: "",
      };
    case UPDATE_ADMIN_AIRTICKET_FAIL:
      return {
        ...state,
        updateAdminAirTicketLoading: false,
        updateAdminAirTicketInfo: [],
        updateAdminAirTicketError: payload,
      };
    default:
      return state;
  }
};

export const getAdminAirTicketReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_ADMIN_AIRTICKET_LIST_REQUEST:
      return {
        ...state,
        getAdminAirTicketLoading: true,
      };
    case GET_ADMIN_AIRTICKET_LIST_SUCCESS:
      return {
        ...state,
        getAdminAirTicketLoading: false,
        getAdminAirTicketInfo: payload,
        getAdminAirTicketError: "",
      };
    case GET_ADMIN_AIRTICKET_LIST_FAIL:
      return {
        ...state,
        getAdminAirTicketLoading: false,
        getAdminAirTicketInfo: [],
        getAdminAirTicketError: payload,
      };
    default:
      return state;
  }
};

export const deleteAdminAirTicketReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case DELETE_ADMIN_AIRTICKET_REQUEST:
      return {
        ...state,
        deleteAdminAirTicketLoading: true,
      };
    case DELETE_ADMIN_AIRTICKET_SUCCESS:
      return {
        ...state,
        deleteAdminAirTicketLoading: false,
        deleteAdminAirTicketInfo: payload,
        deleteAdminAirTicketError: "",
      };
    case DELETE_ADMIN_AIRTICKET_FAIL:
      return {
        ...state,
        deleteAdminAirTicketLoading: false,
        deleteAdminAirTicketInfo: [],
        deleteAdminAirTicketError: payload,
      };
    default:
      return state;
  }
};
